<div class="form-group p-field">
    <span class=" w-full p-input-icon-right">
        <i [ngClass]="showPass ? 'pi pi-eye-slash' : 'pi pi-eye'" (click)="showPass = !showPass"></i>
        <input [type]="showPass? 'text' : 'password'" pInputText name="password" (ngModelChange)="onPasswordChanged()"
            [formControlName]="controlName" [placeholder]="placeholder | translate "
            (keyup.enter)="runAction($event)" style="width: inherit;"/>
    </span>
</div>